<template>
  <div
    v-if="selectSubcertificate"
    class="d-flex align-items-center justify-content-start mb-1"
  >
    <v-select
      v-if="!dataLoad"
      v-model="showNameSubCertificate"
      class="w-100"
      :options="subCertificateLocalOptions"
      placeholder="Select By Sub Certificate"
      label="text"
      multiple
      :searchable="true"
      :clearable="true"
      @input="searchSubCertificateTable"
      @clear="clearSubCertificateSelection"
    />
  </div>
</template>

<script>
import axios from 'axios'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    'v-select': VSelect,
  },
  props: {
    selectSubcertificate: {
      type: Boolean,
      default: () => false,
    },
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    subCertificateOptions: {
      type: Array,
      default: () => [],
    },

  },
  data() {
    return {
      showNameSubCertificate: null,
      subCertificateLocalOptions: [],

    }
  },
  watch: {
    subCertificateOptions(val) {
      this.subCertificateLocalOptions = val
    },
    subCertificateLocalOptions: {
      handler(newOptions) {
        const subCertQuery = this.$route.query.sub_certificate

        // Prevent running includes on undefined
        if (!subCertQuery) return

        const matched = newOptions.filter(
          /* eslint-disable-next-line */
         item => subCertQuery.includes(String(item.value)),
        )
        if (matched.length === 0) return
        this.showNameSubCertificate = matched
      },
      immediate: true,
    },
  },
  mounted() {
    axios
      .get('certificate/get-sub')
      .then(res => {
        const dataSubCertificate = decryptData(res.data.payload)?.data
          ?.groups
        this.subCertificateLocalOptions = dataSubCertificate.map(item => ({
          value: item.id,
          text: `${item.name?.ar} - ${item.name?.en}`,
        }))
      })
  },
  methods: {
    searchSubCertificateTable(selectedOption) {
      if (!selectedOption) {
        this.$emit('getSubCertificateIdGroup', null)
        this.showNameSubCertificate = null
      } else {
        const selectedValueOption = selectedOption.map(item => item.value)
        this.$emit('getSubCertificateIdGroup', selectedValueOption)
      }
    },
    clearSubCertificateSelection() {
      this.$emit('getSubCertificateIdGroup', null)
      this.showNameSubCertificate = null
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
